<template>
  <div id="acChargeSetTem">
    <el-row class="content" style="margin-top: -45px;padding: 0;">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="contentTitle" style="display: flow-root;position: absolute;right: 2px;top: 13px;z-index: 99;">
          <el-button v-show="editBtn" type="primary" icon="el-icon-edit " style="vertical-align: top;float: right;margin-left: 10px;" @click="edit" />
          <el-button v-show="closeBtn" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="close" /><!--取消-->
          <el-button v-show="viewBtn=='close'" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="clickSet('close')" /><!--收起配置-->
          <!--配置-->
          <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" :disabled="disabledEdit" @click="clickSet('open')" />
          <!-- <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" @click="clickSet('open')" /> -->
        </p>
        <!-- 配置-查看 -->
        <div v-if="viewTable" class="contentWrap" style="padding:0;margin-top: 10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index" :class="{'bag':item.key=='CH1'||item.key=='CH2'||item.key=='CH3'}">
                  <td style="text-align: center;position:relative;">
                    <span v-if="item.key!='chargeStage'" style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                    <div v-if="item.key=='chargeStage'">
                      <span style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                      <i class="el-icon-question" style="font-size:20px;color: #fff;position: relative;vertical-align: middle;" @mouseover="mouseoverQuestion(item)" @mouseout="mouseoutQuestion(item)" />
                      <!-- 问号弹窗 -->
                      <div class="questionPop">
                        <img src="@/assets/images/kisae/2chargeStage.jpg" alt="">
                        <img src="@/assets/images/kisae/3chargeStage.jpg" alt="">
                      </div>
                    </div>
                  </td>
                  <td style="text-align: left;">
                    <!-- <p v-if="item.key=='model'">{{ modelType }}</p> -->
                    <p v-if="item.key=='model'">AC {{ machineModel }}</p>
                    <el-switch v-if="item.key=='CH1'||item.key=='CH2'||item.key=='CH3'" v-model="tableEditObj[item.key]" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" :disabled="true" @change="resetOnOff(tableEditObj[item.key],item.key)" />
                    <el-select v-if="item.key=='batteryTypeCh1'" v-model="tableEditObjBatteryTypeCh1" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='batteryTypeCh2'" v-model="tableEditObjBatteryTypeCh2" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in batteryTypeOptions2" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='batteryTypeCh3'" v-model="tableEditObjBatteryTypeCh3" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in batteryTypeOptions2" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='GAFChargeOrFloatA'" v-model="tableEditObj[item.key+item.sort]" :options="GAFAOptions" clearable :disabled="true" />
                    <el-select v-if="item.key=='proV'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in proVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='proA'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in proAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='lithiumV'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in lithiumVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='lithiumChargeOrFloatA'" v-model="tableEditObj[item.key+item.sort]" :options="liCharOrFloatAOptions" clearable :disabled="true" />
                    <!-- <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj[item.key+item.sort]" label="1">ON</el-radio>
                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj[item.key+item.sort]" label="2">OFF</el-radio> -->
                    <el-radio v-if="item.key=='chargeStage'" v-model="tableEditObj[item.key+item.sort]" label="2" :disabled="true">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='chargeStage'" v-model="tableEditObj[item.key+item.sort]" label="3" :disabled="true">3 Stages Mode</el-radio>

                    <el-select v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in eqStatusOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="1" :disabled="true">cold</el-radio>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="2" :disabled="true">normal</el-radio>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="3" :disabled="true">hot</el-radio>
                    <el-radio v-if="item.key=='aotoOnoff'" v-model="tableEditObj.aotoOnoff" label="1" :disabled="true">ENABLE</el-radio>
                    <el-radio v-if="item.key=='aotoOnoff'" v-model="tableEditObj.aotoOnoff" label="2" :disabled="true">DISABLE</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="1" :disabled="true">CH1</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="2" :disabled="true">CH2</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="3" :disabled="true">CH3</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="4" :disabled="true">OFF</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <!-- <tr>
                  <td colspan="3">
                    <el-button type="primary" style="vertical-align: top;margin-right: 20px;float: right;" @click="tableSubmit('charging')">提交</el-button>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <!-- 配置-编辑 -->
        <div v-if="editTable" class="contentWrap" style="padding:0;margin-top:10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index" :class="{'bag':item.key=='CH1'||item.key=='CH2'||item.key=='CH3'}">
                  <td style="text-align: center;position:relative;">
                    <span v-if="item.key!='chargeStage'" style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                    <div v-if="item.key=='chargeStage'">
                      <span style="position: relative;vertical-align: middle;">{{ item.name }}</span>
                      <i class="el-icon-question" style="font-size:20px;color: #fff;position: relative;vertical-align: middle;" @mouseover="mouseoverQuestion(item)" @mouseout="mouseoutQuestion(item)" />
                      <!-- 问号弹窗 -->
                      <div class="questionPop">
                        <img src="@/assets/images/kisae/2chargeStage.jpg" alt="">
                        <img src="@/assets/images/kisae/3chargeStage.jpg" alt="">
                      </div>
                    </div>
                  </td>
                  <td style="text-align: left;">
                    <p v-if="item.key=='model'">AC {{ machineModel }}</p>
                    <el-switch v-if="item.key=='CH1'||item.key=='CH2'||item.key=='CH3'" v-model="tableEditObj[item.key]" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="resetOnOff(tableEditObj[item.key],item.key)" />
                    <el-select v-if="item.key=='batteryTypeCh1'" v-model="tableEditObjBatteryTypeCh1" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='batteryTypeCh2'" v-model="tableEditObjBatteryTypeCh2" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in batteryTypeOptions2" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='batteryTypeCh3'" v-model="tableEditObjBatteryTypeCh3" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in batteryTypeOptions2" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='GAFChargeOrFloatA'" v-model="tableEditObj[item.key+item.sort]" :options="GAFAOptions" />
                    <el-select v-if="item.key=='proV'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in proVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='proA'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in proAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='lithiumV'" v-model="tableEditObj[item.key+item.sort]" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in lithiumVOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-cascader v-if="item.key=='lithiumChargeOrFloatA'" v-model="tableEditObj[item.key+item.sort]" :options="liCharOrFloatAOptions" />
                    <!-- <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj[item.key+item.sort]" label="1">ON</el-radio>
                    <el-radio v-if="item.key=='eqStatus'" v-model="tableEditObj[item.key+item.sort]" label="2">OFF</el-radio> -->
                    <el-radio v-if="item.key=='chargeStage'" v-model="tableEditObj[item.key+item.sort]" label="2" @change="change($event)">2 Stages Mode</el-radio>
                    <el-radio v-if="item.key=='chargeStage'" v-model="tableEditObj[item.key+item.sort]" label="3" @change="change($event)">3 Stages Mode</el-radio>

                    <el-select v-if="item.key=='eqStatus'" v-model="tableEditObj.eqStatus" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in eqStatusOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="1" @change="change($event)">cold</el-radio>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="2" @change="change($event)">normal</el-radio>
                    <el-radio v-if="item.key=='tempCompensation'" v-model="tableEditObj.tempCompensation" label="3" @change="change($event)">hot</el-radio>
                    <el-radio v-if="item.key=='aotoOnoff'" v-model="tableEditObj.aotoOnoff" label="1" @change="change($event)">ENABLE</el-radio>
                    <el-radio v-if="item.key=='aotoOnoff'" v-model="tableEditObj.aotoOnoff" label="2" @change="change($event)">DISABLE</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="1" @change="change($event)">CH1</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="2" @change="change($event)">CH2</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="3" @change="change($event)">CH3</el-radio>
                    <el-radio v-if="item.key=='chargePriority'" v-model="tableEditObj.chargePriority" label="4" @change="change($event)">OFF</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <tr style="height: 40px;">
                  <td colspan="3">
                    <el-button type="primary" style="vertical-align: top;margin-right: 2px;float: right;" @click="tableSubmit('charging')">{{ $t('button.Submit') }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setTCCfg, getTCCfg } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'Bidirectional',
  components: {
  },
  props: {
    // machineModel: {
    //   type: String,
    //   default: ''
    // },
    online: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acOnline: false,
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      machineModel: null,
      disabledEdit: true,
      tableEditObj: {
        CH1: true,
        CH2: true,
        CH3: true,
        GAFChargeOrFloatACh1: [],
        GAFChargeOrFloatACh2: [],
        GAFChargeOrFloatACh3: [],
        lithiumChargeOrFloatACh1: [],
        lithiumChargeOrFloatACh2: [],
        lithiumChargeOrFloatACh3: []
      },
      tableEditObjBatteryTypeCh1: null,
      tableEditObjBatteryTypeCh2: null,
      tableEditObjBatteryTypeCh3: null,
      // tableData: [],
      tableDataAll: [
        { key: 'model', isShow: true, name: 'Model', nameZ: '型号', remark: '' },
        { key: 'CH1', isShow: true, name: 'CH1', nameZ: '输出端', remark: 'Disable/Enable CH1' },
        { key: 'batteryTypeCh1', isShow: true, name: 'Battery Type', nameZ: '电池类型', remark: 'Select battery type, relevant information will be shown.Type of battery include: GEL,AGM,FLOODED,LITHIUM,PGM' },
        { key: 'GAFChargeOrFloatA', sort: 'Ch1', isShow: true, name: 'Bulk Current / Float Current', nameZ: '充电电流/浮充电流', remark: 'Bulk/float stage charging current setting. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'proV', sort: 'Ch1', isShow: true, name: 'Bulk Voltage', nameZ: '充电电压', remark: 'Absorption stage voltage .13.5V，13.7V，13.3V' },
        { key: 'proA', sort: 'Ch1', isShow: true, name: 'Bulk Current ', nameZ: '充电电流', remark: 'Select the bulk stage charging current,10A，15A，20A，5A' },
        { key: 'lithiumV', sort: 'Ch1', isShow: false, name: 'Bulk Voltage', nameZ: '充电电压', remark: 'Absorption stage voltage for Lithium battery .Range 13.9 - 14.6 (0.1V step).' },
        { key: 'lithiumChargeOrFloatA', sort: 'Ch1', isShow: false, name: 'Bulk Current / Float Current', nameZ: '型充电电流/浮充电流号', remark: 'Bulk/float stage charging current setting for Lithium battery. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'chargeStage', sort: 'Ch1', isShow: true, name: 'Charge Mode', nameZ: '充电模式', remark: 'charging mode. 2 stages= bulk and absorption,for standard charging, 3 states=bulk,absorption and float,for fast charging.' },
        // { key: 'eqStatus', sort: 'Ch1', isShow: true, name: 'EQ Status', nameZ: '电池修复功能', remark: '' },
        // { key: 'tempCompensation', sort: 'Ch1', isShow: true, name: 'Temp Mode', nameZ: '温度补偿模式', remark: '' },
        // { key: 'aotoOnoff', sort: 'Ch1', isShow: true, name: 'Fan Quiet Mode', nameZ: '风扇静音模式', remark: '' },
        // { key: 'chargePriority', sort: 'Ch1', isShow: true, name: 'Priority', nameZ: '设置优先', remark: '' },
        // CH2
        { key: 'CH2', isShow: true, name: 'CH2', nameZ: '输出端', remark: 'Disable/Enable CH2' },
        { key: 'batteryTypeCh2', isShow: true, name: 'Battery Type', nameZ: '电池类型', remark: 'Select battery type, relevant information will be shown.Type of battery include: GEL,AGM,FLOODED,LITHIUM,PGM' },
        { key: 'GAFChargeOrFloatA', sort: 'Ch2', isShow: true, name: 'Bulk Current / Float Current', nameZ: '充电电流/浮充电流', remark: 'Bulk/float stage charging current setting. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'proV', sort: 'Ch2', isShow: true, name: 'Bulk Voltage', nameZ: '充电电压', remark: 'Absorption stage voltage .13.5V，13.7V，13.3V' },
        { key: 'proA', sort: 'Ch2', isShow: true, name: 'Bulk Current ', nameZ: '充电电流', remark: 'Select the bulk stage charging current,10A，15A，20A，5A' },
        { key: 'chargeStage', sort: 'Ch2', isShow: true, name: 'Charge Mode', nameZ: '充电模式', remark: 'charging mode. 2 stages= bulk and absorption,for standard charging, 3 states=bulk,absorption and float,for fast charging.' },
        // { key: 'eqStatus', sort: 'Ch2', isShow: true, name: 'EQ Status', nameZ: '电池修复功能', remark: '' },
        // { key: 'tempCompensation', sort: 'Ch2', isShow: true, name: 'Temp Mode', nameZ: '温度补偿模式', remark: '' },
        // { key: 'aotoOnoff', sort: 'Ch2', isShow: true, name: 'Fan Quiet Mode', nameZ: '风扇静音模式', remark: '' },
        // { key: 'chargePriority', sort: 'Ch2', isShow: true, name: 'Priority', nameZ: '设置优先', remark: '' },
        // ch3
        { key: 'CH3', isShow: true, name: 'CH3', nameZ: '输出端', remark: 'Disable/Enable CH3' },
        { key: 'batteryTypeCh3', isShow: true, name: 'Battery Type', nameZ: '电池类型', remark: 'Select battery type, relevant information will be shown.Type of battery include: GEL,AGM,FLOODED,LITHIUM,PGM' },
        { key: 'GAFChargeOrFloatA', sort: 'Ch3', isShow: true, name: 'Bulk Current / Float Current', nameZ: '充电电流/浮充电流', remark: 'Bulk/float stage charging current setting. Used to determine the termination current.(e.g. If set to 5A, termination current can be 1A/1.5A/2A)' },
        { key: 'proV', sort: 'Ch3', isShow: true, name: 'Bulk Voltage', nameZ: '充电电压', remark: 'Absorption stage voltage .13.5V，13.7V，13.3V' },
        { key: 'proA', sort: 'Ch3', isShow: true, name: 'Bulk Current ', nameZ: '充电电流', remark: 'Select the bulk stage charging current,10A，15A，20A，5A' },
        { key: 'chargeStage', sort: 'Ch3', isShow: true, name: 'Charge Mode', nameZ: '充电模式', remark: 'charging mode. 2 stages= bulk and absorption,for standard charging, 3 states=bulk,absorption and float,for fast charging.' },
        // { key: 'eqStatus', sort: 'Ch3', isShow: true, name: 'EQ Status', nameZ: '电池修复功能', remark: '' },
        // { key: 'tempCompensation', sort: 'Ch3', isShow: true, name: 'Temp Mode', nameZ: '温度补偿模式', remark: '' },
        // { key: 'aotoOnoff', sort: 'Ch3', isShow: true, name: 'Fan Quiet Mode', nameZ: '风扇静音模式', remark: '' },
        // { key: 'chargePriority', sort: 'Ch3', isShow: true, name: 'Priority', nameZ: '设置优先', remark: '' }

        // { key: 'chargeStage', isShow: true, name: 'Charge Mode', nameZ: '充电模式', remark: '' },
        { key: 'eqStatus', isShow: true, name: 'EQ Status', nameZ: '电池修复功能', remark: 'Disable/enable equalization function (for flooded battery only). If enabled, can extend the life of battery.' },
        { key: 'tempCompensation', isShow: true, name: 'Temp Mode', nameZ: '温度补偿模式', remark: 'Temperature compensation. COLD: used when ambient temp.<5℃  NORMAL:used when 5<=ambient temp.<=30℃  HOT: used when ambient temp>30℃' },
        { key: 'aotoOnoff', isShow: true, name: 'Fan Quiet Mode', nameZ: '风扇静音模式', remark: 'Enable if required quiet environment. Disable if ambient temperature is high.If enabled, charging current will be reduced. If disabled the cooling fan will run in full speed. ' },
        { key: 'chargePriority', isShow: true, name: 'Priority', nameZ: '设置优先', remark: 'Charging priority for CH1,CH2,CH3.' }
      ],
      batteryTypeOptions: [
        { label: 'GEL', value: '5' },
        { label: 'AGM', value: '1' },
        { label: 'Flooded', value: '2' },
        { label: 'Lithium', value: '3' },
        { label: 'Program', value: '4' }
      ],

      batteryTypeOptions2: [
        { label: 'GEL', value: '5' },
        { label: 'AGM', value: '1' },
        { label: 'Flooded', value: '2' },
        // { label: 'Lithium', value: '4' },
        { label: 'Program', value: '4' }
      ],
      eqStatusOptions: [
        { label: 'CH1 opens EQ', value: '1' },
        { label: 'CH2 opens EQ', value: '2' },
        { label: 'CH3 opens EQ', value: '3' },
        { label: 'Close all EQ', value: '4' }
      ],
      GAFAOptions: [],
      proVOptions: [
        { label: '13.3 V', value: '3' },
        { label: '13.5 V', value: '1' },
        { label: '13.7 V', value: '2' }
      ],
      proAOptions: [
        { label: '5 A', value: '4' },
        { label: '10 A', value: '1' },
        { label: '15 A', value: '2' },
        { label: '20 A', value: '3' }
      ],
      lithiumVOptions: [
        { label: '13.9 V', value: '8' },
        { label: '14.0 V', value: '1' },
        { label: '14.1 V', value: '2' },
        { label: '14.2 V', value: '3' },
        { label: '14.3 V', value: '4' },
        { label: '14.4 V', value: '5' },
        { label: '14.5 V', value: '6' },
        { label: '14.6 V', value: '7' }
      ],
      liCharOrFloatAOptions: [
        {
          value: '4',
          label: 'Bulk 5A',
          children: [
            { value: '1', label: 'Float 0.5A' },
            { value: '2', label: 'Float 1A' },
            { value: '3', label: 'Float 0.25A' }
          ]
        },
        {
          value: '1',
          label: 'Bulk 10A',
          children: [
            { value: '1', label: 'Float 1A' },
            { value: '2', label: 'Float 2A' },
            { value: '3', label: 'Float 0.5A' }
          ]
        },
        {
          value: '2',
          label: 'Bulk 15A',
          children: [
            { value: '1', label: 'Float 1.5A' },
            { value: '2', label: 'Float 3A' },
            { value: '3', label: 'Float 0.75A' }
          ]
        },
        {
          value: '3',
          label: 'Bulk 20A',
          children: [
            { value: '1', label: 'Float 2A' },
            { value: '2', label: 'Float 4A' },
            { value: '3', label: 'Float 1A' }
          ]
        }
      ],
      mGetCANCfgData: null
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
    // modelType() {
    //   return this.machineModel
    // }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    },
    online: {
      handler(newValue, oldValue) {
        this.acOnline = newValue
        if (newValue) { this.disabledEdit = false } else { this.disabledEdit = true }
      },
      deep: true
    },
    tableEditObjBatteryTypeCh1: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    tableEditObjBatteryTypeCh2: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          // v.isShow = true
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    tableEditObjBatteryTypeCh3: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          // v.isShow = true
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    machineModel: {// 型号
      handler(newValue, oldValue) {
        console.log(newValue)
        if (!newValue) return
        if (newValue.indexOf('2012') > -1 || newValue.indexOf('1220') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 15A',
              children: [
                { value: '1', label: 'Float 0.75A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('4012') > -1 || newValue.indexOf('1240') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 0.75A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('6012') > -1 || newValue.indexOf('1260') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 60A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 12A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('3024') > -1 || newValue.indexOf('2430') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 1.5A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 6A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        }
      },
      deep: true,
      immediate: true

    }
  },
  mounted() {
    // getTCCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
  },
  created() {
  },
  destroyed: function() {
  },
  methods: {
    mouseoverQuestion(item) {
      document.querySelectorAll('.questionPop')[item.sort.slice(2) - 1].style.display = 'block'
    },
    mouseoutQuestion(item) {
      document.querySelectorAll('.questionPop')[item.sort.slice(2) - 1].style.display = 'none'
      // document.querySelectorAll('.questionPop')[index].style.display = 'none'
    },
    resetOnOff(value, name) {
      if (!value) {
        this.tableDataAll.forEach(v => {
          if (name == 'CH1' && (v.sort == 'Ch1' || v.key == 'batteryTypeCh1'))v.isShow = false
          if (name == 'CH2' && (v.sort == 'Ch2' || v.key == 'batteryTypeCh2'))v.isShow = false
          if (name == 'CH3' && (v.sort == 'Ch3' || v.key == 'batteryTypeCh3'))v.isShow = false
        })
      } else { // 打开
        var old1 = this.tableEditObjBatteryTypeCh1 // 避免关闭后再打开时将锂电池的信息也默认带出，所以触发tableEditObjBatteryTypeCh1监听
        var old2 = this.tableEditObjBatteryTypeCh2
        var old3 = this.tableEditObjBatteryTypeCh3
        this.tableDataAll.forEach(v => {
          if (name == 'CH1' && (v.sort == 'Ch1' || v.key == 'batteryTypeCh1')) { v.isShow = true; this.tableEditObjBatteryTypeCh1 = 0; this.tableEditObjBatteryTypeCh1 = old1 }
          if (name == 'CH2' && (v.sort == 'Ch2' || v.key == 'batteryTypeCh2')) { v.isShow = true; this.tableEditObjBatteryTypeCh2 = 0; this.tableEditObjBatteryTypeCh2 = old2 }
          if (name == 'CH3' && (v.sort == 'Ch3' || v.key == 'batteryTypeCh3')) { v.isShow = true; this.tableEditObjBatteryTypeCh3 = 0; this.tableEditObjBatteryTypeCh3 = old3 }
        })
      }
    },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        getTCCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    change(e) {
      this.$forceUpdate()
    },
    tableSubmit() {
      // console.log(this.tableEditObj)
      // console.log(this.tableEditObjBatteryTypeCh1)
      // console.log(this.tableEditObjBatteryTypeCh2)
      // console.log(this.tableEditObjBatteryTypeCh3)
      var param = {
        'mcuId': this.$route.query.mcuId,
        'temp_compensation': this.tableEditObj.tempCompensation,
        'type_of_ch1': this.tableEditObjBatteryTypeCh1, // 电池类型
        'type_of_ch2': this.tableEditObjBatteryTypeCh2,
        'type_of_ch3': this.tableEditObjBatteryTypeCh3,
        // 'ch1_limit_I': 0,//AGF--充电电流
        // 'ch2_limit_I': 0,
        // 'ch3_limit_I': 0,
        'ch1_lithium_chg_V': this.tableEditObj.lithiumVCh1, // 锂电池--充电电压
        'ch2_lithium_chg_V': this.tableEditObj.lithiumVCh2,
        'ch3_lithium_chg_V': this.tableEditObj.lithiumVCh3,
        // 'ch1AbsEsc_I': 0,//AGF--浮充电流
        // 'ch2AbsEsc_I': 0,
        // 'ch3AbsEsc_I': 0,
        // 'ch1_lithium_limit_I': 0, // 锂电池--充电电流
        // 'ch2_lithium_limit_I': 0,
        // 'ch3_lithium_limit_I': 0,
        'ch1_program_chg_limit_I': this.tableEditObj.proACh1, // pro--充电电流
        'ch2_program_chg_limit_I': this.tableEditObj.proACh2,
        'ch3_program_chg_limit_I': this.tableEditObj.proACh3,
        'ch1_program_V': this.tableEditObj.proVCh1, // pro--充电电压
        'ch2_program_V': this.tableEditObj.proVCh2,
        'ch3_program_V': this.tableEditObj.proVCh3,
        'eQ_status': this.tableEditObj.eqStatus,
        'charge_priority': this.tableEditObj.chargePriority,
        'aotO_onoff': this.tableEditObj.aotoOnoff,
        // 'ch1_lithium_esc_I': 0, // 锂电池--浮充电流
        // 'ch2_lithium_esc_I': 0,
        // 'ch3_lithium_esc_I': 0,
        'ch1_charge_stage': this.tableEditObj.chargeStageCh1,
        'ch2_charge_stage': this.tableEditObj.chargeStageCh2,
        'ch3_charge_stage': this.tableEditObj.chargeStageCh3,
        'model': '4012'
      }
      for (var i in param) {
        if (!param[i]) delete param[i]
      }
      if (this.tableEditObj.GAFChargeOrFloatACh1) {
        param.ch1_limit_I = this.tableEditObj.GAFChargeOrFloatACh1[0]
        param.ch1_abs_esc_I = this.tableEditObj.GAFChargeOrFloatACh1[1]
      }
      if (this.tableEditObj.GAFChargeOrFloatACh2) {
        param.ch2_limit_I = this.tableEditObj.GAFChargeOrFloatACh2[0]
        param.ch2_abs_esc_I = this.tableEditObj.GAFChargeOrFloatACh2[1]
      }
      if (this.tableEditObj.GAFChargeOrFloatACh3) {
        param.ch3_limit_I = this.tableEditObj.GAFChargeOrFloatACh3[0]
        param.ch3_abs_esc_I = this.tableEditObj.GAFChargeOrFloatACh3[1]
      }
      if (this.tableEditObj.lithiumChargeOrFloatACh1) {
        param.ch1_lithium_limit_I = this.tableEditObj.lithiumChargeOrFloatACh1[0]
        param.ch1_lithium_esc_I = this.tableEditObj.lithiumChargeOrFloatACh1[1]
      }
      if (this.tableEditObj.lithiumChargeOrFloatACh2) {
        param.ch2_lithium_limit_I = this.tableEditObj.lithiumChargeOrFloatACh2[0]
        param.ch2_lithium_esc_I = this.tableEditObj.lithiumChargeOrFloatACh2[1]
      }
      if (this.tableEditObj.lithiumChargeOrFloatACh3) {
        param.ch3_lithium_limit_I = this.tableEditObj.lithiumChargeOrFloatACh3[0]
        param.ch3_lithium_esc_I = this.tableEditObj.lithiumChargeOrFloatACh3[1]
      }
      // if (this.tableEditObj.CH1) { param.type_of_ch1 = 1 } else { param.type_of_ch1 = 0 }
      // if (this.tableEditObj.CH2) { param.type_of_ch2 = 1 } else { param.type_of_ch2 = 0 }
      // if (this.tableEditObj.CH3) { param.type_of_ch3 = 1 } else { param.type_of_ch3 = 0 }
      console.log(this.tableEditObj.lithiumChargeOrFloatACh1)
      console.log(param)
      this.$confirm('submit change?', '', {// '是否提交修改？'
        confirmButtonText: 'Confirm', // '确定',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        setTCCfg(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
            this.viewTable = this.editBtn = true
            this.editTable = this.closeBtn = false
            this.viewBtn = 'close'
          }
        })
      }).catch(() => {
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          var mCanData = this.yhubmqtt.mCan
          // console.log('payload***', mCanData.payload)
          if (!mCanData) return
          if (mCanData && mCanData.payload === 'mGetCANCfgData') {
            this.mGetCANCfgData = mCanData.mGetCANCfgData.TCcfg //
            console.log('mGetCANCfgData-ac充电器cfg--', this.mGetCANCfgData)
            if (!this.mGetCANCfgData) {
              return
            }
            if (this.mGetCANCfgData) {
              this.disabledEdit = false
              this.machineModel = this.mGetCANCfgData.model.toString(16)
              this.tableEditObj.typeOfCh1 = this.tableEditObjBatteryTypeCh1 = this.mGetCANCfgData.typeOfCh1.toString()
              this.tableEditObj.typeOfCh2 = this.tableEditObjBatteryTypeCh2 = this.mGetCANCfgData.typeOfCh2.toString()
              this.tableEditObj.typeOfCh3 = this.tableEditObjBatteryTypeCh3 = this.mGetCANCfgData.typeOfCh3.toString()
              this.tableEditObj.lithiumVCh1 = this.mGetCANCfgData.ch1LithiumChg_V.toString()
              this.tableEditObj.lithiumVCh2 = this.mGetCANCfgData.ch2LithiumChg_V.toString()
              this.tableEditObj.lithiumVCh3 = this.mGetCANCfgData.ch3LithiumChg_V.toString()
              this.tableEditObj.tempCompensation = this.mGetCANCfgData.tempCompensation.toString()
              this.tableEditObj.proACh1 = this.mGetCANCfgData.ch1ProgramChgLimit_I.toString()
              this.tableEditObj.proACh2 = this.mGetCANCfgData.ch2ProgramChgLimit_I.toString()
              this.tableEditObj.proACh3 = this.mGetCANCfgData.ch3ProgramChgLimit_I.toString()
              this.tableEditObj.proVCh1 = this.mGetCANCfgData.ch1LithiumChg_V.toString()
              this.tableEditObj.proVCh2 = this.mGetCANCfgData.ch2LithiumChg_V.toString()
              this.tableEditObj.proVCh3 = this.mGetCANCfgData.ch3LithiumChg_V.toString()
              this.tableEditObj.eqStatus = this.mGetCANCfgData.EQStatus.toString()
              this.tableEditObj.chargePriority = this.mGetCANCfgData.chargePriority.toString()
              this.tableEditObj.chargeStageCh1 = this.mGetCANCfgData.ch1ChargeStage.toString()
              this.tableEditObj.chargeStageCh2 = this.mGetCANCfgData.ch2ChargeStage.toString()
              this.tableEditObj.chargeStageCh3 = this.mGetCANCfgData.ch3ChargeStage.toString()
              this.tableEditObj.aotoOnoff = this.mGetCANCfgData.AOTOOnoff.toString()
              if (this.mGetCANCfgData.ch1Limit_I && this.mGetCANCfgData.ch1AbsEsc_I) {
                this.tableEditObj.GAFChargeOrFloatACh1 = []
                this.tableEditObj.GAFChargeOrFloatACh1.push(this.mGetCANCfgData.ch1Limit_I.toString(), this.mGetCANCfgData.ch1AbsEsc_I.toString())
              }
              if (this.mGetCANCfgData.ch2Limit_I && this.mGetCANCfgData.ch2AbsEsc_I) {
                this.tableEditObj.GAFChargeOrFloatACh2 = []
                this.tableEditObj.GAFChargeOrFloatACh2.push(this.mGetCANCfgData.ch2Limit_I.toString(), this.mGetCANCfgData.ch2AbsEsc_I.toString())
              }
              if (this.mGetCANCfgData.ch3Limit_I && this.mGetCANCfgData.ch3AbsEsc_I) {
                this.tableEditObj.GAFChargeOrFloatACh3 = []
                this.tableEditObj.GAFChargeOrFloatACh3.push(this.mGetCANCfgData.ch3Limit_I.toString(), this.mGetCANCfgData.ch3AbsEsc_I.toString())
              }
              if (this.mGetCANCfgData.c1LithiumLimit_I && this.mGetCANCfgData.ch1LithiumEsc_I) {
                this.tableEditObj.lithiumChargeOrFloatACh1 = []
                this.tableEditObj.lithiumChargeOrFloatACh1.push(this.mGetCANCfgData.ch1LithiumLimit_I.toString(), this.mGetCANCfgData.ch1LithiumEsc_I.toString())
              }
              if (this.mGetCANCfgData.ch2LithiumLimit_I && this.mGetCANCfgData.ch2LithiumEsc_I) {
                this.tableEditObj.lithiumChargeOrFloatACh2 = []
                this.tableEditObj.lithiumChargeOrFloatACh2.push(this.mGetCANCfgData.ch2LithiumLimit_I.toString(), this.mGetCANCfgData.ch2LithiumEsc_I.toString())
              }
              if (this.mGetCANCfgData.ch3LithiumLimit_I && this.mGetCANCfgData.ch3LithiumEsc_I) {
                this.tableEditObj.lithiumChargeOrFloatACh3 = []
                this.tableEditObj.lithiumChargeOrFloatACh3.push(this.mGetCANCfgData.ch3LithiumLimit_I.toString(), this.mGetCANCfgData.ch3LithiumEsc_I.toString())
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.bag{
  background:#e0e0e085;
}
.card-panel{
  padding-bottom: 20px;
}
#acChargeSetTem{
  .content{
    // background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    height: 550px;
    width: 100%;
    // background: white;
    padding-top: 20px;
  }
  .middleContentLeft{
    // height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middleContentLeft>div{
    // border:1px solid red;
    // width:100px;
    // height:200px;
  }
  .plugWarp>div:nth-of-type(1){
    display: flex;
    justify-content: center;
  }
  .plugWarp>div:nth-of-type(1) img{
    width: 100px;
    margin-bottom: 10px;
  }
  .plugWarp>div:nth-of-type(2){
    text-align: center;
  }
  .plugWarp>div:nth-of-type(2) img{
    width:30px;
  }
  .plugWarp>div:nth-of-type(2) span{
    line-height: 30px;
    vertical-align: top;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #63bb38;
  }
  .greenDeltaRight{//向右三角形
    width: 0;
    height: 0;
    border-left: 15px solid #63bb38;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .acChargeDiv{
    position: relative;
  }
  .acChargeDiv div:first-child p{
    text-align: center;
  }
  .acChargeDiv>div{
    display: inline-block;
  }
  .acChargeDiv .acChargeInfo{
    vertical-align: top;
  }
  .acChargeInfo>div{
    margin-top:40px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -45px;
  }

  .middleContentRight{
    height: 400px;
    // border:1px solid red;
    position: relative;
    padding-left: 20px;
  }
  .middleContentRight>div{
    // border:1px solid red;
    // height:80px;
    position: absolute;
  }
  .arrowOrLine{
    border-top: 3px solid #63bb38;
    border-right: 3px solid #63bb38;
    position: relative;
  }
  .greenDeltaBottom{
    position: absolute;
    bottom: -5px;
    right: -11px;
  }
  .middleContentRight>div:nth-of-type(1){
    width:calc(100% - 100px);
    top: 47px;
    height: 74px;
  }
  .middleContentRight>div:nth-of-type(2){
    width:calc(100% - 280px);
    top: 105px;
    height: 96px;
  }
  .middleContentRight>div:nth-of-type(3){
    width:calc(100% - 460px);
    top: 162px;
    height: 118px;
  }
  .middleContentRight>div:nth-of-type(4){
    right: 0;
    top: 130px;
  }
  .middleContentRight>div:nth-of-type(5){
    right: 180px;
    top: 210px;
  }
  .middleContentRight>div:nth-of-type(6){
    right: 360px;
    top: 290px;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  .cellTeamBoxImg{
    display: flex;
    justify-content: center;
  }
  .cellTeamBox>img{
    width: 160px;
  }
  .cellTeamBoxInfo{
    text-align: center;
  }
  .cellTeamBoxInfo img{
    width:30px;
  }
  .cellTeamBoxInfo span{
    line-height: 30px;
    vertical-align: top;
  }
  .dottedLine{
   border-top: 3px dotted #e3e3e3;
   border-right: 3px dotted #e3e3e3;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    // color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
  .acChargeWarp{
    padding:0 5%;
  }
  // .acChargeDiv{
  //   position: relative;
  // }
  .acChargeImg{
    width:150px;
    // border:1px solid red;
  }
}
</style>

<style lang="scss">
#acChargeSetTem{
  .contentWrap {
    background: #27679e;
  }
  .btnSpace{
    height: 40px;
    border: 1px solid #537ba3;
    border-bottom: none;
  }
  .el-radio {
    color: #fff;
  }
  .el-switch__label.is-active {
    color: #1990fc;
  }
  .el-switch__label {
    color: #ffffff;
  }
  .questionPop{
    display: none;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    width: 200%;
    // bottom: 55px;
    // left: 10px;
    // max-width: 100%;
  }
  .questionPop img{
    width:100%;
  }
}
</style>
